import React from 'react';
import { Root, Circle, Animation, Animation2, Animation3 } from './styles';
import { cx } from '@linaria/core';
export function Loading({ height = '100%' }) {
    /** JSX */
    return (React.createElement("div", { className: cx(Root.base), "aria-label": "Anwendung wird geladen", "aria-live": "polite", style: { height: height } },
        React.createElement("div", { className: cx(Circle.base), role: "progressbar", "aria-busy": "true", "aria-label": "L\u00E4dt" },
            React.createElement("div", { className: cx(Animation.base) }),
            React.createElement("div", { className: cx(Animation2.base) }),
            React.createElement("div", { className: cx(Animation3.base) }))));
}
export default Loading;
